
<template>
  <div id="app">
    <router-view></router-view> <!-- 核心修改：路由渲染出口 -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 确保全屏显示 */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
